import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
export function CTABanner() {
  return <section className="py-20 bg-chocolate relative overflow-hidden" data-id="element-40">
      {/* Decorative circles */}
      <div className="absolute top-0 left-0 w-64 h-64 bg-white/5 rounded-full -translate-x-1/2 -translate-y-1/2" data-id="element-41" />
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-gold/10 rounded-full translate-x-1/3 translate-y-1/3" data-id="element-42" />

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center" data-id="element-43">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-4xl md:text-5xl font-serif text-cream mb-6" data-id="element-44">
          Start Your Care Journey Today
        </motion.h2>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.1
      }} className="text-lg text-cream/80 mb-10 max-w-2xl mx-auto" data-id="element-45">
          Whether you need immediate support or are planning for the future, our
          team is ready to guide you with compassion and expertise.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} className="flex flex-col sm:flex-row justify-center gap-4" data-id="element-46">
          <Link to="/contact" className="bg-gold text-chocolate px-8 py-4 rounded-full font-bold text-lg hover:bg-white transition-colors shadow-lg hover:shadow-xl" data-id="element-47">
            Contact Our Team
          </Link>
          <a href="tel:+1234567890" className="px-8 py-4 rounded-full font-medium text-cream border border-cream/30 hover:bg-cream/10 transition-colors" data-id="element-48">
            Call (555) 123-4567
          </a>
        </motion.div>
      </div>
    </section>;
}